import { ViewportScroller } from '@angular/common';

/**
 * Reset window scroll after entering a page.
 * Angular `scrollPositionRestoration: 'enabled'` often runs while the outgoing
 * page is still tall, so a mid-page Y sticks on equally tall destinations
 * (orbit workbench, dictionary list, provider hub).
 */
export function scrollViewportToTop(viewportScroller?: ViewportScroller | null): void {
  const scroll = (): void => {
    viewportScroller?.scrollToPosition([0, 0]);
    if (typeof globalThis.window !== 'undefined') {
      globalThis.window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  scroll();
  if (typeof globalThis.requestAnimationFrame !== 'function') {
    return;
  }
  globalThis.requestAnimationFrame(() => {
    scroll();
    globalThis.requestAnimationFrame(scroll);
  });
}
